/*
 * File: index.tsx
 * Project: meki
 * File Created: Thursday, 15th April 2021 9:52:06 am
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Monday, 19th December 2022 3:20:31 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2020 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
export * from './SuggestionsForm';
